/**
 * Add `forSale` to the development object.
 */
const addForSaleFlag = (development) => {
  development.isForSale = development.values.condoToggle;
}

export default addForSaleFlag;
